import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

// POST /api/v1/legal/create-document
// Creates a legal document (e.g. Terms and Conditions, Privacy Policy).
// payload: { content, contentFormat, type, icon }
export const createLegalDocument = async (documentData) => {
  try {
    const response = await axios.post(
      `${API_URL}legal/create-document`,
      documentData,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// GET /api/v1/legal/admin/list
// Returns the list of legal documents (policies) for the admin panel.
export const getLegalDocuments = async () => {
  try {
    const response = await axios.get(`${API_URL}legal/admin/list`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// The backend exposes no GET /api/v1/legal/:id route (it 404s). The admin list
// endpoint already returns the full document (including content), so we resolve
// a single policy for the edit form by fetching the list and matching on id.
export const getLegalDocumentById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}legal/admin/list`, getAuthHeaders());
    const payload = response.data;
    const list =
      payload?.data ??
      payload?.documents ??
      payload?.policies ??
      (Array.isArray(payload) ? payload : []);
    const doc = (Array.isArray(list) ? list : []).find(
      (d) => String(d.id ?? d._id) === String(id)
    );
    if (!doc) {
      throw new Error("Policy not found");
    }
    return { data: doc };
  } catch (error) {
    throw error.response?.data || error;
  }
};

// PATCH /api/v1/legal/:id
// Updates an existing legal document.
export const updateLegalDocument = async (id, documentData) => {
  try {
    const response = await axios.patch(
      `${API_URL}legal/${id}`,
      documentData,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// GET /api/v1/video-lessons/signed-url?videoUrl=...
// The S3 bucket is private, so stored image URLs need a fresh, time-limited
// signed URL to be viewable. This shared endpoint signs any object in the
// bucket, so we use it to display images embedded in policy content on edit.
export const getSignedMediaUrl = async (assetUrl) => {
  try {
    const response = await axios.get(
      `${API_URL}video-lessons/signed-url?videoUrl=${encodeURIComponent(assetUrl)}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// DELETE /api/v1/legal/:id
// Deletes a legal document.
export const deleteLegalDocument = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}legal/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
